import { FrameEndTimeBuffer } from '../models/frameEndTimes';

/**
 * Calculate framerate info about the current minute
 * @param currentMinute the buffer corresponding to the current minute of data
 * @param addMinuteInfo A callback to track the info about the current minute.
 */
export default function calculateCurrentMinute(
    currentMinute: FrameEndTimeBuffer,
    addMinuteInfo: (avgFps: number, wasTabInBackground: boolean) => void
) {
    let wasTabInBackground = false;

    for (let i = 0; i < currentMinute.length; i++) {
        if (currentMinute.buffer[i].isNextFrameBackground) {
            wasTabInBackground = true;
            break;
        }
    }

    const avgFrameDuration =
        (currentMinute.buffer[currentMinute.length - 1].time - currentMinute.buffer[0].time) /
        (currentMinute.length - 1);
    const avgFps = 1000 / avgFrameDuration;

    // Call the callback to store this info. Written as a callback to abstract
    // out any memory allocations.
    addMinuteInfo(avgFps, wasTabInBackground);
}
